<div class="column content-container">
	<div class="content-container-header">
		<h3 i18n="@@addDeviceNoteConfirmation-confirmation"><b>Confirmation</b></h3>
		<mat-divider></mat-divider>

		<div class="content-container-body">
			@if (showLoading) {
				<div>
					<mat-spinner diameter="35" style="float: left"></mat-spinner>
					<h3 style="float: left; margin-top: 7px; margin-left: 1em" i18n="@@addDeviceNoteConfirmation-loadingMessage">
						Loading...
					</h3>
				</div>
			}

			@if (showSuccess) {
				<div>
					@if (!fileDetails || (fileDetails && fileDetails.length === 0)) {
						<p id="greatNewsWithoutPhoto">
							<b i18n="@@addDeviceNoteConfirmation-confirm_withoutPhoto_greatNews" class="highlight">Great news! </b
							><ng-container i18n="@@addDeviceNoteConfirmation-confirm_withoutPhoto_note"
								>You left a note for future visits within your company.</ng-container
							>
						</p>
					}
					@if (fileDetails && fileDetails.length > 0) {
						<p id="greatNewsWithPhoto">
							<b i18n="@@addDeviceNoteConfirmation-confirm_withPhoto_greatNews" class="highlight">Great news! </b
							><ng-container i18n="@@addDeviceNoteConfirmation-confirm_withPhoto_youUploaded"
								>You've uploaded </ng-container
							><b class="highlight">{{ fileDetails.length }}</b
							><ng-container i18n="@@addDeviceNoteConfirmation-confirm_withPhoto_photoAndNote">
								photo(s) and left a note for future visits within your company.</ng-container
							>
						</p>
					}
					<div>
						<h3 i18n="@@addDeviceNoteConfirmation-confirmation_note" class="highlight">Note</h3>
						{{ note }}
					</div>
					<mat-grid-list cols="2" rowHeight="200px" gutterSize="25px">
						@for (fileDetail of fileDetails; track fileDetail.file.name) {
							<mat-grid-tile [colspan]="1">
								<div class="container">
									<div class="col-1 photo-preview">
										<img [src]="fileDetail.previewURL" />
									</div>
									<div class="col-2">
										<p class="header" i18n="@@addDeviceNoteConfirmation-fileName">File Name</p>
										<p class="details">{{ fileDetail.file.name }}</p>
										<br />
										<p class="header" i18n="@@addDeviceNoteConfirmation-caption">Caption</p>
										<p class="details">{{ fileDetail.caption }}</p>
									</div>
								</div>
							</mat-grid-tile>
						}
					</mat-grid-list>
				</div>
			}

			@if (showFailure) {
				<div>
					<h3 i18n="@@addDeviceNoteConfirmation-confirmation_error">
						Error when adding note <b>{{ note }}</b> to device <b>{{ deviceSN }}</b> with the assigned role
					</h3>
				</div>
			}

			@if (showSuccess || showFailure) {
				<div>
					<div style="margin-top: 24px; margin-bottom: 24px">
						<br />
						<mat-divider></mat-divider>
					</div>
				</div>
			}
		</div>

		<div style="float: left; margin-top: 8px">
			<button
				mat-button
				(click)="onDeviceNotesClicked()"
				class="primary-button"
				i18n="@@addDeviceNote-returtNoteDirectoryButton"
				data-automation-id="return-to-device-notes-button"
			>
				Return to Device Notes
			</button>
			<button
				mat-button
				(click)="onAddNoteClicked()"
				class="secondary-button"
				i18n="@@addDeviceNote-addAnotherNoteButton"
				data-automation-id="add-another-note-button"
			>
				+ Add Another Note
			</button>
		</div>
	</div>
</div>
